import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './converters-app-project.css';
import convertersAppImage from '../../../assets/images/Converters App Image.png';
import qrCodeImg from '../../../assets/images/Converters-App.png';

const ConvertersAppProject = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Converters <span>App Project</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        Last Updated On: 14th March 2025
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={convertersAppImage} alt="Converters App Project" className="project-image" />
          <h2 className="project-subtitle">Converter App</h2>
          <span className="project-category">Tools</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="convertersApp" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://converters-app-online.web.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Converters-App" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "convertersApp",
                title: "Converters App Project",
                path: "/projects/projectdetail/converters-app-project"
              }}
            />
          </div>

          <div className="qr-container">
            <img src={qrCodeImg} alt="QR Code" className="qr-image" />
          </div>

        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The Converter Tools are designed to provide fast, accurate, and user-friendly solutions for various conversions, making it an essential utility for everyday tasks.
          </p>

          <h3 className="section-title">📌 Available Converters</h3>
          <ul className="feature-list">
            <li>
              <strong>💱 Currency Converter</strong><br />
              Convert between major world currencies.<br />
              Real-time exchange rate updates.<br />
              Supports multiple currencies at once.
            </li>
            <li>
              <strong>📉 EMI Calculator</strong><br />
              Calculate Equated Monthly Installments for loans.<br />
              Supports principal, interest rate, and tenure inputs.<br />
              Displays total interest and total payment breakdown.<br />
              Shows EMI in both INR & USD rates based on real-time conversion.
            </li>
            <li>
              <strong>🧾 Monthly Expense Calculator</strong><br />
              Track and manage your monthly expenses efficiently.<br />
              Supports income input in both INR & USD.<br />
              Add multiple expense categories and sub-categories.<br />
              Displays an Expense Summary in a table format.<br />
              Calculates Total Expenses and Remaining Balance dynamically.<br />
              Shows expenses in both INR & USD rates based on real-time conversion.<br />
              Includes Add Expense and Reset buttons for easy management.
            </li>
            <li>
              <strong>⚡ Electricity Bill Calculator</strong><br />
              Estimate monthly electricity bills based on usage.<br />
              Customizable per-unit cost based on region.<br />
              Breakdown of consumption by appliance.<br />
              Displays bill amount in both INR & USD rates for better understanding.
            </li>
            <li>
              <strong>🎚️ Pressure Converter</strong><br />
              Convert between Pascal, Bar, PSI.<br />
              Supports absolute and gauge pressure.<br />
              Essential for mechanical/engineering use.
            </li>
            <li>
              <strong>🏎️ Speed Converter</strong><br />
              Convert between kph, mph, m/s, etc.<br />
              Useful for sports, vehicles, and navigation.
              Includes Mach speed conversion for aviation purposes.
            </li>
            <li>
              <strong>🌡️ Temperature Converter</strong><br />
              Convert between Celsius, Fahrenheit, and Kelvin.<br />
              Quick and easy unit selection for instant results.<br />
              Includes scientific temperature scales for advanced users.
            </li>
            <li>
              <strong>📏 Unit Converter</strong><br />
              Convert between length, area, weight, and more.<br />
              Supports metric and imperial systems.<br />
              Comprehensive unit list for scientific and practical use.
            </li>
            <li>
              <strong>📦 Volume Converter</strong><br />
              Convert between liters, milliliters, gallons, and cubic meters.<br />
              Essential for cooking, engineering, and industrial applications.<br />
              Precise decimal calculations for accuracy.
            </li>
            <li>
              <strong>💡 Light Converter <em>(In Progress...)</em></strong><br />
              Convert between lumens, lux, candela, and foot-candles.<br />
              Useful for photography, lighting design, and physics applications.<br />
              Coming soon with real-time simulation features.
            </li>
          </ul>

          <h3 className="section-title">📣 More Converters Coming Soon...</h3>
          <p>Stay tuned for more exciting converter tools to make calculations even easier! 🚀</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ConvertersAppProject;
